import { CompanyAttributes } from "@albatrosdeveloper/ave-models-package";
import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { ReactiveFormsModule, FormsModule, FormBuilder, FormGroup } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableModule, MatRowDef } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CompanyService } from "../../configuration/company/company.service.service";
import {
  NgSelectComponent,
  NgSelectModule,
} from "@ng-select/ng-select";
import { ICreateBusinessPartnerGroup } from "./interfaces/create-business-partner-group.interface";
import BusinessPartnerGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-group/business-partner-group.entity";
import { BusinessPartnerGroupService } from "./business-partner-group.service";
import { IUpdateBusinessPartnerGroup } from "./interfaces/update-business-partner-group.interface";
import PriceListAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/price-list/price-list.entity";
import { PriceListService } from "../../master/price-list/price-list.service";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { getCode } from "app/utils/method";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { Subscription } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";


@Component({
  selector: "app-business-partner-group",
  standalone: true,
  templateUrl: "./business-partner-group.component.html",
  styleUrl: "./business-partner-group.component.scss",
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent,
    NgSelectModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
})
export class BusinessPartnerGroupComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;

  displayedColumns: string[] = ["name", "code", "statusId", "actions"];
  currentCreateBusinessPartnerGroup: ICreateBusinessPartnerGroup =
    this.initializeCreateBusinessPartnerGroup();
  currentUpdateBusinessPartnerGroup: BusinessPartnerGroupAttributes | undefined;

  companyList: CompanyAttributes[] = [];
  selectedCompanyIds: string[] = [];
  priceList: PriceListAttributes[] = [];

  dataSource: BusinessPartnerGroupAttributes[] = [];
  searchQuery = "";
  totalItems = 0;
  pageSize = 50;
  pageIndex = 0;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  //BUSCADOR
  searchSubscription: Subscription;

  selectedStatuses: [] = [];
  form: FormGroup;

  // Lazy loading flags
  loadFiltersData = false;
  private companiesLoaded = false;
  private priceListsLoaded = false;

  constructor(
    private readonly companyService: CompanyService,
    private readonly priceListService: PriceListService,
    private readonly businessgroupService: BusinessPartnerGroupService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      companyId: []
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private initializeCreateBusinessPartnerGroup(): ICreateBusinessPartnerGroup {
    return { name: "", companyId: "", priceListId: null };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
      this.companiesLoaded = true;
    });
  }

  private fetchPriceList(): void {
    this.priceListService.findToComboBoxPriceList().subscribe((res) => {
      this.priceList = res.data;
      this.priceListsLoaded = true;
    });
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";

    this.businessgroupService
      .findAllWithCount({
        currentPage: pageIndex,
        limitPerPage: this.pageSize,
        search: this.searchQuery,
        sort: sortField,
        sortDirection: sortDirection,
      },
      this.form.get("companyId").get,
      this.selectedStatuses
    )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof BusinessPartnerGroupAttributes {
    const validSortFields: (keyof BusinessPartnerGroupAttributes)[] = [
      "id",
      "name",
      "statusId",
    ];
    return validSortFields.includes(
      this.sort.active as keyof BusinessPartnerGroupAttributes
    )
      ? (this.sort.active as keyof BusinessPartnerGroupAttributes)
      : "id";
  }

  onCompanySelectionChange(selectedIds: string[]): void {
    this.selectedCompanyIds = selectedIds;
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: BusinessPartnerGroupAttributes): string {
    return item._id.toString();
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  clearFilters(): void {
    this.selectedStatuses = [];
    this.form.reset({
      companyId: null
    });
    this.findAllWithCount();
  }

  private ensureCompaniesLoaded(): void {
    if (!this.companiesLoaded) {
      this.fetchCompanies();
    }
  }

  private ensurePriceListsLoaded(): void {
    if (!this.priceListsLoaded) {
      this.fetchPriceList();
    }
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    this.ensureCompaniesLoaded();
  }

  private ensureModalDataLoaded(): void {
    this.ensureCompaniesLoaded();
    this.ensurePriceListsLoaded();
  }

  openCreateModal(): void {
    this.ensureModalDataLoaded();
    this.currentCreateBusinessPartnerGroup =
    this.initializeCreateBusinessPartnerGroup();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose: true})
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createBusinessPartnerGroup());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(materialBrand: BusinessPartnerGroupAttributes): void {
    this.ensureModalDataLoaded();
    this.currentUpdateBusinessPartnerGroup = {
      ...materialBrand
    };
    this.dialogRefEdit  = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) =>result &&this.updateBusinessPartnerGroup(materialBrand._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createBusinessPartnerGroup(): void {
    this.businessgroupService
      .create(this.currentCreateBusinessPartnerGroup)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          this.dialogRefAdd.close();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  updateBusinessPartnerGroup(id: string): void {
    if (this.currentUpdateBusinessPartnerGroup) {
      const updatedBusinessPartnerGroup: IUpdateBusinessPartnerGroup = {
        companyId: this.currentUpdateBusinessPartnerGroup.company._id.toString(),
        priceListId: this.currentUpdateBusinessPartnerGroup.priceList?._id.toString() || null,
        ...this.currentUpdateBusinessPartnerGroup,
      };

      this.businessgroupService
        .update(id, updatedBusinessPartnerGroup)
        .subscribe({
          next: () => {
            this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
              duration: 3000,
            });
            this.findAllWithCount();
            this.dialogRefEdit.close();
          },
          error: (err) => {
            this.snackBar.open(
              err.error.message || "Error al actualizar el registro",
              "Cerrar",
              { duration: 3000 }
            );
          },
        });
    }
  }

  onStatusChange(
    event: boolean,
    materialBrand: BusinessPartnerGroupAttributes
  ): void {
    const originalStatusId = materialBrand.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBusinessPartnerGroup = {
      ...materialBrand,
      statusId: updatedStatusId,
    };

    this.businessgroupService
      .update(materialBrand._id.toString(), updatedBusinessPartnerGroup)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          materialBrand.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  openDeleteDialog(materialBrand: BusinessPartnerGroupAttributes): void {
    this.dialog
      .open(this.deleteDialog, {
        data: materialBrand,
        panelClass: "delete-modal",
        disableClose:true
      })
      .afterClosed()
      .subscribe(
        (result) => result && this.delete(materialBrand._id.toString())
      );
  }

  delete(id: string): void {
    this.businessgroupService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  onPriceSelectionChange(priceListId: string): void {
    if (this.currentUpdateBusinessPartnerGroup) {
      this.currentUpdateBusinessPartnerGroup.priceList = this.priceList.find(
        (price) => price._id.toString() === priceListId
      )!;
    }
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
